import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

interface CertificationsInitialStateType {
  data: {
    name: string,
    children: [{
      name: string,
      icon: string,
      children: [{
        name: string,
        url: string,
        icon: string,
        presentedBy: string,
        organization: string
      }]
    }]
  }
  loading: boolean
  status: number | null
  errorStatus: number | null
}

const initialState: CertificationsInitialStateType = {
  data: {
    name: "",
    children: [{
      name: "",
      icon: "",
      children: [{
        name: "",
        url: "",
        icon: "",
        presentedBy: "",
        organization: ""
      }]
    }]
  },
  loading: false,
  status: null,
  errorStatus: null
}

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const getCertifications = createAsyncThunk('CertificationsSlice/getCertifications', async (_, thunkApi) => {
  try {
    const response = await axios.get(apiUrl + '/certifications')
    const data = await response.data.data
    return thunkApi.fulfillWithValue(data)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status)
  }
})

const CertificationsSlice = createSlice({
  name: "CertificationsSlice",
  initialState,
  reducers: {
    getValue: (state, action) => {
      state.data = action.payload
    },
    resetValue: (state) => {
      state.data = {
        name: "",
        children: [{ name: "", icon: "", children: [{ name: "", url: "", icon: "", presentedBy: "", organization: "" }] }] }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCertifications.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getCertifications.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getCertifications.rejected, (state, action) => {
      state.errorStatus = action.payload as number
    })
    builder.addMatcher(isAnyOf(
      getCertifications.fulfilled, getCertifications.rejected), (state) => {
        state.loading = false
      })
  }
})

const CertificationsThunks = {
  getCertifications,
}

export const CertificationsServices = {
  ...CertificationsThunks,
  actions: CertificationsSlice.actions,
}

const CertificationsReducer = CertificationsSlice.reducer
export default CertificationsReducer